import React from "react"
import NewHeader from "../components/layout/NewHeader"
import Modal from "../components/layout/modal"
import { ProductCard } from "../components/tadaShop/ProductCard"
import { Controls } from "../components/layout/menu_help"
import { CartBtn } from "../components/tadaShop/CardBtn"
import { Navigation, Grid } from 'swiper';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import 'swiper/css'
import 'swiper/css/navigation'
import { ShoppingCart } from "../components/tadaShop/ShoppingCart"
import { OrderModal } from "../components/tadaShop/OrderModal"
import { useFetch } from "../hooks/useFetch"
import { fetchPath } from "../config/defPath"
import { CartProduct } from "../hooks/useCartStore"

interface DataPropsShop {
    title: string
    desc: string
    products: CartProduct[]
}

export default function TadaSore() {
    const {data, isLoading} = useFetch(`${fetchPath}/aguila/loyalty/assets-cart`)

    if (isLoading) return <></>

    const config: SwiperProps = {
        modules: [Navigation, Grid],
        spaceBetween: 15,
        slidesPerView: 2,
        slidesPerGroup: 2,
        grid: {
            fill: 'row',
            rows: window.innerWidth <= 991 ? 2 : 1,
        },
        navigation: {
            nextEl: '.ar__tadaShop__navigation--next',
            prevEl: '.ar__tadaShop__navigation--prev',
        },
        breakpoints: {
            991: {
                spaceBetween: 30,
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },
    }

    const goNextOrPrevSlide = (action: 'Preview' | 'Next') => {
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Content',
            'event_action': 'Button',
            'event_label': `${action}`,
            'interaction':'true',
            'component_name': 'Modo_Carrera_Tada',
            'element_text': `${action}`,
        });
    }
    
    return (
        <section id="tadaShop" className="ar__tadaShop">
            <NewHeader />
            <Controls isStadium={false} />
            <Modal />
            <CartBtn />

            {
                data ? (
                    <div className="ar__tadaShop__box blur-slow">
                        <h1 className="ar__tadaShop__title" dangerouslySetInnerHTML={{__html: data.title}}></h1>
                        <div className="ar__tadaShop__subtitle" dangerouslySetInnerHTML={{__html: data.desc}}></div>

                        {data.products.length > 0 && (
                            <Swiper {...config} >
                                {
                                    data.products.map((item: CartProduct) => (
                                        <>
                                            {item.active && (
                                                <SwiperSlide key={item.sku}>
                                                    <ProductCard data={item} />
                                                </SwiperSlide>
                                            )}
                                        </>
                                    )
                                    )
                                }
                            </Swiper>
                        )}

                        <div className="ar__tadaShop__navigation">
                            <button className="ar__tadaShop__navigation--prev" onClick={() => goNextOrPrevSlide('Preview')}>Atras</button>
                            <button className="ar__tadaShop__navigation--next" onClick={() => goNextOrPrevSlide('Next')}>Adelante</button>
                        </div>
                    </div>
                ) : (<div>No Data</div>)
            }

            <ShoppingCart urltada={data.popup.url} />

            <OrderModal pupup={data.popup} />

        </section>
    )
}

